import { render, staticRenderFns } from "./NoRealTaskPage.vue?vue&type=template&id=2b1b110c&"
import script from "./NoRealTaskPage.vue?vue&type=script&lang=js&"
export * from "./NoRealTaskPage.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports